export default "__VITE_ASSET__DCJUfNe___"